angular.module('impactx.controlstructure').controller('ASNCtrl', [
    '$scope',
    '$controller',
    'ToolbarService',
    ASNCtrl
]);

function ASNCtrl($scope, $controller, ToolbarService) {
    var self = this;
    angular.extend(self, $controller('ControlStructureCtrl', {$scope: $scope}));

    $scope.endPointView = "/control/asn/view";
    $scope.endPointSave = "/control/asn/save";
    $scope.endPointDelete = "/control/asn/delete";

    $scope.getPageData().then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageData,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: $scope.delete,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.asn.readOnly;
    }

    function canDelete() {
        return $scope.id > 0 && !$scope.data.asn.readOnly && !$scope.data.asn.deprecated;
    }
}